import React, { useState, useRef } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { isEmail } from "validator";

import AuthService from "services/auth.service";
import { Row, Col } from "reactstrap";
import {API_URL_IMAGE} from "../../services/config";


const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

const validEmail = (value) => {
  if (!isEmail(value)) {
    return (
      <div className="alert alert-danger" role="alert">
        This is not a valid email.
      </div>
    );
  }
};

const vpassword = (value) => {
  if (value.length < 6 || value.length > 40) {
    return (
      <div className="alert alert-danger" role="alert">
        The password must be between 6 and 40 characters.
      </div>
    );
  }
};

const Register = () => {
  const form = useRef();
  const checkBtn = useRef();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [ssn, setSsn] = useState("");
  const [address, setAddress] = useState("");
  const [gender, setGender] = useState("");
  const [availableBalance, setAvailableBalance] = useState("");
  const [pendingPayment, setPendingPayment] = useState("");
  const [transactionTotalFee, setTransactionTotalFee] = useState("");
  const [transactionRefundableFee, setTransactionRefundableFee] = useState("");
  const [imageURL, setImageURL] = useState("");
  const [successful, setSuccessful] = useState(false);
  const [message, setMessage] = useState("");

  const [file, setFile] = useState();

  const onChangeEmail = (e) => {
    const email = e.target.value;
    setEmail(email);
  };

  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };
  const onChangeFirstName = (e) => {
    const firstName = e.target.value;
    setFirstName(firstName);
  };
  const onChangeLastName = (e) => {
    const lastName = e.target.value;
    setLastName(lastName);
  };
  const onChangeDOB = (e) => {
    const dateOfBirth = e.target.value;
    setDateOfBirth(dateOfBirth);
  };
  const onChangeMobile = (e) => {
    const mobileNumber = e.target.value;
    setMobileNumber(mobileNumber);
  };
  const onChangeSSN = (e) => {
    const ssn = e.target.value;
    setSsn(ssn);
  };
  const onChangeADD = (e) => {
    const address = e.target.value;
    setAddress(address);
  };
  const onChangeGender = (e) => {
    const gender = e.target.value;
    setGender(gender);
  };
  const onChangeAvail = (e) => {
    const availableBalance = e.target.value;
    setAvailableBalance(availableBalance);
  };
  const onChangePend = (e) => {
    const pendingPayment = e.target.value;
    setPendingPayment(pendingPayment);
  };
  const onChangeTransactionTotalFee = (e) => {
    const transactionTotalFee = e.target.value;
    setTransactionTotalFee(transactionTotalFee);
  };
  const onChangeTransactionRefundableFee = (e) => {
    const transactionRefundableFee = e.target.value;
    setTransactionRefundableFee(transactionRefundableFee);
  };

  const saveFile = (e) => {
    e.preventDefault();
    setFile(e.target.files[0]);
  };
  const handleImageUpload = async () => {
    try {
      const formData = new FormData();
      formData.append("file", file);
  
      const response = await AuthService.upload(formData);
      setMessage(response.imageUrl);
      console.log(response.imageUrl);
      console.log('this is the return response: ' + response) // Return the response data
      setImageURL(`${API_URL_IMAGE}${response.imageUrl}`);
      setSuccessful(true);
      return response;
      
    } catch (error) {
      // Handle errors here
      const resMessage =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      setMessage(resMessage);
      setSuccessful(false);
      throw error; // Re-throw the error to be caught by the caller
    }
    
};

const handleRegister = async (e) => {
  e.preventDefault();
  setMessage("");
  setSuccessful(false);
  form.current.validateAll();

  try {
    let formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);
    formData.append("firstName", firstName);
    formData.append("lastName", lastName);
    formData.append("dateOfBirth", dateOfBirth);
    formData.append("mobileNumber", mobileNumber);
    formData.append("gender", gender);
    formData.append("availableBalance", availableBalance);
    formData.append("pendingPayment", pendingPayment);
    formData.append("transactionTotalFee", transactionTotalFee);
    formData.append("transactionRefundableFee", transactionRefundableFee);
    formData.append("address", address);

    if (imageURL) {
      formData.append("profileImage", imageURL);
    }

    // Proceed with form submission only if image upload is successful
    if (checkBtn.current.context._errors.length === 0) {
      const response = await AuthService.register(formData);
      setMessage(response.data.message);
      setSuccessful(true);

      setTimeout(() => {}, 2000);
      setTimeout(() => {
        //window.location.reload();
      }, 1000);  
    }
  } catch (error) {
    // Handle errors here
    const resMessage =
      (error.response &&
        error.response.data &&
        error.response.data.message) ||
      error.message ||
      error.toString();

    setMessage(resMessage);
    setSuccessful(false);
  }
};

  // const handleRegister = (e) => {
  //   e.preventDefault();
  //   setMessage("");
  //   setSuccessful(false);
  //   form.current.validateAll();

  //   handleImageUpload();
    
    

  //   if (checkBtn.current.context._errors.length === 0) {
  //     AuthService.register(
  //       email,
  //       password,
  //       firstName,
  //       lastName,
  //       dateOfBirth,
  //       mobileNumber,
  //       ssn,
  //       address,
  //       gender,
  //       availableBalance,
  //       pendingPayment,
  //       transactionTotalFee,
  //       transactionRefundableFee,
  //       imageURL,
  //     ).then(
  //       (response) => {
  //         setMessage(response.data.message);
  //         setSuccessful(true);
  //       },
  //       (error) => {
  //         const resMessage =
  //           (error.response &&
  //             error.response.data &&
  //             error.response.data.message) ||
  //           error.message ||
  //           error.toString();

  //         setMessage(resMessage);
  //         setSuccessful(false);
  //       }
  //     );
  //   }
  // };

  const myInlineStyles = {
    padding: "20px",
  };

  return (
    <div className="content">
      <Row>
        <Col>
          <div className="col-md-6 ">
            <div className="card card-container" style={myInlineStyles}>
              <Form onSubmit={handleRegister} ref={form}>
                {!successful && (
                  <div>
                    <div className="form-group">
                      <label htmlFor="email">Email</label>
                      <Input
                        type="text"
                        className="form-control"
                        name="email"
                        value={email}
                        onChange={onChangeEmail}
                        validations={[required, validEmail]}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="password">Password</label>
                      <Input
                        type="password"
                        className="form-control"
                        name="password"
                        value={password}
                        onChange={onChangePassword}
                        validations={[required, vpassword]}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="firstname">First Name</label>
                      <Input
                        type="text"
                        className="form-control"
                        name="firstName"
                        value={firstName}
                        onChange={onChangeFirstName}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="lastname">Last Name</label>
                      <Input
                        type="text"
                        className="form-control"
                        name="lastName"
                        value={lastName}
                        onChange={onChangeLastName}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="dob">Date of Birth (MM/DD/YYYY)</label>
                      <Input
                        type="text"
                        className="form-control"
                        name="dateOfBirth"
                        value={dateOfBirth}
                        onChange={onChangeDOB}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="mobile">mobile number</label>
                      <Input
                        type="text"
                        className="form-control"
                        name="mobileNumber"
                        value={mobileNumber}
                        onChange={onChangeMobile}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="ssn">SSN</label>
                      <Input
                        type="text"
                        className="form-control"
                        name="ssn"
                        value={ssn}
                        onChange={onChangeSSN}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="address">address</label>
                      <Input
                        type="text"
                        className="form-control"
                        name="address"
                        value={address}
                        onChange={onChangeADD}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="gender">Gender</label>
                      <Input
                        type="text"
                        className="form-control"
                        name="gender"
                        value={gender}
                        onChange={onChangeGender}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="available">Available Balance</label>
                      <Input
                        type="text"
                        className="form-control"
                        name="availableBalance"
                        value={availableBalance}
                        onChange={onChangeAvail}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="pending">Pending Balance</label>
                      <Input
                        type="text"
                        className="form-control"
                        name="pendingBalance"
                        value={pendingPayment}
                        onChange={onChangePend}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="transactionTotal">
                        Transaction Page Non Refundable Fee Total
                      </label>
                      <Input
                        type="text"
                        className="form-control"
                        name="transactionTotalFee"
                        value={transactionTotalFee}
                        onChange={onChangeTransactionTotalFee}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="transactionRefundable">
                        Transaction Page refundable Fee Total
                      </label>
                      <Input
                        type="text"
                        className="form-control"
                        name="transactionRefundableFee"
                        value={transactionRefundableFee}
                        onChange={onChangeTransactionRefundableFee}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="imagePath">Image</label>
                      <Input
                        type="file"
                        className="form-control"
                        name="imagePath"
                        onChange={saveFile}
                        required
                      />
                      {/* {imagePath && <p>Selected File: {imagePath}</p>} */}
                    </div>

                    <div className="form-group">
                      <button className="btn btn-primary btn-block">
                        Create New User
                      </button>
                    </div>
                  </div>
                )}

                {message && (
                  <div className="form-group">
                    <div
                      className={
                        successful
                          ? "alert alert-success"
                          : "alert alert-danger"
                      }
                      role="alert"
                    >
                      {message}
                    </div>
                  </div>
                )}
                <CheckButton style={{ display: "none" }} ref={checkBtn} />
              </Form>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Register;
